import { Filter } from "@/types/filter.type";
import { MenuItem } from "@/types/menuItem.type";
import { responseHandlerDefault } from "@/utils/handler.util";
import axios from "./api";

/**
 * do login
 * @param username
 * @param password
 * @returns
 */
export const getMenuItems = (filter?: Filter): Promise<MenuItem[]> => {
  const params: { filter?: Filter } = {};
  if (filter) {
    params.filter = filter;
  }
  return axios
    .get<MenuItem[]>(`/menuItems/`, { params })
    .then(responseHandlerDefault)
    .then((res) => {
      return res.data;
    })
    .catch((res) => {
      throw new Error(res.status);
    });
};
export const newMenuItems = (menuItem: MenuItem): Promise<MenuItem[]> => {
  return axios
    .post<MenuItem[]>(`/menuItems/`, menuItem)
    .then(responseHandlerDefault)
    .then((res) => {
      return res.data;
    })
    .catch((res) => {
      throw new Error(res.status);
    });
};
// export const getmenuItemsByUser =(userId: number): Promise<MenuItem[]> => {
//     return axios
//         .get<MenuItem[]>(`/menuItems/`, userId).then(responseHandlerDefault)
//         .then((res) => {
//             return res.data;
//         })
//         .catch((res) => {
//             throw new Error(res.status);
//         });
//     }
